const defaultFormConfig = [
  {
    type: 'basic',
    title: '基本信息',
    fields: [
      {
        fieldType: 'Input',
        name: 'name',
        label: '姓名',
        rule: 'REQ'
      },
      {
        fieldType: 'RadioGroup',
        name: 'gender',
        label: '性别',
        rule: 'REQ',
        enum: {
          moduleName: 'gender'
        },
        computedProps: ({ enum: options }) => {
          return {
            options: options.map(item => ({
              label: item.description,
              value: item.value
            }))
          };
        }
      },
      {
        fieldType: 'DatePicker',
        name: 'birth',
        label: '出生日期',
        interceptor: 'date-string',
        props: {
          picker: 'month',
          disabledDate: date => {
            return date.valueOf() - new Date() > 0;
          }
        }
      },
      {
        fieldType: 'AddressSelect',
        name: 'currentLocation',
        label: '现居城市',
        rule: 'REQ',
        props: {
          single: true,
          onlyAllowLastLevel: true
        }
      },
      {
        fieldType: 'Select',
        name: 'currentSalary',
        label: '当前月薪',
        props: {
          showSearch: true,
          options: Array.from(new Array(100).keys()).map(item => ({ label: `${+item + 1}K`, value: +item + 1 }))
        }
      },
      {
        fieldType: 'PhoneNumber',
        name: 'phoneCode',
        label: '电话',
        rule: 'REQ'
      },
      {
        fieldType: 'Input',
        name: 'email',
        label: '邮箱',
        rule: 'EMAIL'
      },
      {
        fieldType: 'Input',
        name: 'wechat',
        label: '微信'
      }
    ]
  },
  {
    type: 'list',
    title: '求职意向',
    name: 'jobIntention',
    maxLength: 1,
    fields: [
      {
        fieldType: 'FunctionSelect',
        name: 'functionCode',
        label: '期望职位',
        rule: 'REQ',
        props: {
          valueType: 'all',
          // maxLength: 1,
          single: true,
          onlyAllowLastLevel: true
        }
      },
      {
        fieldType: 'IndustrySelect',
        name: 'industryCode',
        label: '期望行业',
        props: {
          valueType: 'all',
          maxLength: 3,
          onlyAllowLastLevel: true
        }
      },
      {
        fieldType: 'AddressSelect',
        name: 'cityCode',
        label: '期望城市',
        props: {
          // maxLength: 1,
          single: true,
          onlyAllowLastLevel: true
        }
      },
      {
        fieldType: 'Select',
        name: 'salary',
        label: '期望月薪',
        props: {
          showSearch: true,
          options: Array.from(new Array(249).keys()).map(item => ({ label: `${+item + 1}K`, value: +item + 1 }))
        }
      }
    ]
  },
  {
    type: 'list',
    title: '教育经历',
    name: 'educations',
    defaultLength: 0,
    fields: [
      {
        fieldType: 'Input',
        name: 'school',
        label: '学校',
        rule: 'LEN-0-100'
      },
      {
        fieldType: 'Select',
        name: 'degree',
        label: '学历',
        enum: {
          moduleName: 'degreeEnum'
        },
        computedProps: ({ enum: options }) => {
          return {
            options: options.map(item => ({
              label: item.description,
              value: item.value
            }))
          };
        }
      },
      {
        fieldType: 'Input',
        name: 'subject',
        label: '专业名称',
        rule: 'LEN-0-100'
      },
      {
        fieldType: 'DatePickerToday',
        name: 'time',
        label: '在校时间',
        interceptor: 'date-range-string',
        props: {
          soFarText: '',
          picker: 'month'
        }
      },
      {
        fieldType: 'RadioGroup',
        name: 'unifiedEnrolment',
        label: '是否统招',
        enum: {
          moduleName: 'confirm'
        },
        computedProps: ({ enum: options }) => {
          return {
            options: options.map(item => ({
              label: item.description,
              value: item.value
            }))
          };
        }
      }
    ]
  },
  {
    type: 'list',
    name: 'works',
    title: '工作经历',
    defaultLength: 0,
    fields: [
      {
        fieldType: 'Input',
        name: 'company',
        label: '公司名称',
        rule: 'LEN-0-100'
      },
      {
        fieldType: 'DatePickerToday',
        name: 'time',
        label: '在职时间',
        interceptor: 'date-range-string',
        props: {
          picker: 'month',
          soFarText: ''
        }
      },
      {
        fieldType: 'InputNumber',
        name: 'salary',
        label: '薪资范围',
        props: {
          min: 0,
          max: 9999999999
        }
      },
      {
        fieldType: 'Input',
        name: 'department',
        label: '所属部门',
        rule: 'LEN-0-50'
      },
      {
        fieldType: 'Select',
        name: 'type',
        label: '公司性质',
        enum: {
          moduleName: 'companyTypeEnum'
        },
        computedProps: ({ enum: options }) => {
          return {
            options: options.map(item => ({
              label: item.description,
              value: item.value
            }))
          };
        }
      },
      {
        fieldType: 'Select',
        name: 'scale',
        label: '公司规模',
        enum: {
          moduleName: 'companyScaleEnum'
        },
        computedProps: ({ enum: options }) => {
          return {
            options: options.map(item => ({
              label: item.description,
              value: item.value
            }))
          };
        }
      },
      {
        fieldType: 'Input',
        name: 'reportTo',
        label: '汇报对象'
      },
      {
        fieldType: 'InputNumber',
        name: 'subordinatesCount',
        label: '下属',
        props: {
          addonAfter: '人',
          min: 0,
          max: 30000
        }
      },
      {
        fieldType: 'TextArea',
        name: 'description',
        label: '工作内容',
        props: {
          block: true,
          showCount: true,
          maxLength: 10000
        }
      }
    ]
  },
  {
    type: 'list',
    name: 'projects',
    title: '项目经历',
    defaultLength: 0,
    fields: [
      {
        fieldType: 'Input',
        name: 'name',
        label: '项目名称',
        rule: 'LEN-0-100'
      },
      {
        fieldType: 'DatePickerToday',
        name: 'time',
        label: '项目时间',
        interceptor: 'date-range-string',
        props: {
          soFarText: '',
          picker: 'month'
        }
      },
      {
        fieldType: 'Input',
        name: 'companyName',
        label: '公司名称',
        rule: 'LEN-0-100'
      },
      {
        fieldType: 'Input',
        name: 'position',
        label: '担任职位',
        rule: 'LEN-0-100'
      },
      {
        fieldType: 'TextArea',
        name: 'description',
        label: '项目描述',
        rule: 'LEN-0-1000',
        props: {
          block: true,
          showCount: true,
          maxLength: 1000
        }
      },
      {
        fieldType: 'TextArea',
        name: 'responsibilities',
        label: '项目职责',
        rule: 'LEN-0-1000',
        props: {
          block: true,
          showCount: true,
          maxLength: 1000
        }
      }
    ]
  },
  {
    type: 'list',
    name: 'languages',
    title: '语言能力',
    defaultLength: 0,
    fields: [
      {
        fieldType: 'Input',
        name: 'name',
        label: '语言名称'
      },
      {
        fieldType: 'Select',
        name: 'level',
        label: '语言等级',
        enum: {
          moduleName: 'levelEnum'
        },
        props: {
          showSearch: true
        },
        computedProps: ({ enum: options }) => {
          return {
            options: options.map(item => ({
              label: item.description,
              value: item.value
            }))
          };
        }
      }
    ]
  },
  {
    type: 'basic',
    title: '自我评价',
    fields: [
      {
        fieldType: 'TextArea',
        name: 'selfRemark',
        label: '自我评价',
        rule: 'LEN-0-1000',
        props: {
          block: true,
          showCount: true,
          maxLength: 1000,
          labelHidden: true,
          placeholder: '介绍自己，突出核心优势'
        }
      }
    ]
  }
];

export default defaultFormConfig;
